
window.__lazy_callback__ = function (lazyModule) {
  return class extends React.Component {
    state = {
      component: null,
    }
    componentWillMount() {
      lazyModule((module) => {
        if (typeof module.default === 'function') {
          this.setState({
            component: module.default,
          });
        } else {
          this.setState({
            component: module,
          });
        }
      });
    }
    render() {
      const Comp = this.state.component;
      return Comp ? <Comp {...this.props} /> : <div />;
    }
  };
}

// common js

// 获取url search 参数
export const getSearchData = (_this, key) => {
  const { search } = _this.props.location
  const paramsString = search.substring(1)
  const searchParams = new URLSearchParams(paramsString)
  const data = searchParams.get(key)
  return data
}

// 返回中文数字
export const getCount = (num) => {
  let count = ''
  switch (num) {
    case 1:
      count = '一'
      break;
    case 2:
      count = '二'
      break;
    case 3:
      count = '三'
      break;
    case 4:
      count = '四'
      break;
    case 5:
      count = '五'
      break;
    case 6:
      count = '六'
      break;
    case 7:
      count = '七'
      break;
    case 8:
      count = '八'
      break;
    case 9:
      count = '九'
      break;
    case 10:
      count = '十'
      break;
    case 11:
      count = '十一'
      break;
    case 12:
      count = '十二'
      break;
  }
  return count
}

// 获取cookie
export const getCookie = name => {
  var arr;
  var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return unescape(arr[2]);
  else
    return null;
}

// 判断是否是chrome浏览器
export const isChrome = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  console.log(userAgent)
  const isChrome = (userAgent.indexOf("chrome") > -1) && (userAgent.indexOf("safari") > -1) && (userAgent.indexOf('edge') < 0)
  console.log('isChrome: ' + isChrome)
  return isChrome
}

String.prototype.format = function(args) {
  var result = this;
  if (arguments.length > 0) {    
    if (arguments.length == 1 && typeof (args) == "object") {
      for (var key in args) {
        if(args[key]!=undefined){
          var reg = new RegExp("({" + key + "})", "g");
          result = result.replace(reg, args[key]);
        }
      }
    }
    else {
      for (var i = 0; i < arguments.length; i++) {
        if (arguments[i] != undefined) {
          var reg= new RegExp("({)" + i + "(})", "g");
          result = result.replace(reg, arguments[i]);
        }
      }
    }
  }
  return result;
}

// 判断操作系统类型
export const getOperatingSystem = () => {
  var sUserAgent = navigator.userAgent;

  // MacOS
  var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
  if (isMac) return "MacOS";

  // Unix
  var isUnix = (navigator.platform == "X11") && !isWindows && !isMac;
  if (isUnix) return "Unix";

  // Linux
  var isLinux = (String(navigator.platform).indexOf("Linux") > -1);
  var bIsAndroid = sUserAgent.toLowerCase().match(/android/i) == "android";
  if (isLinux) {
    if(bIsAndroid) {
      return "Android";
    } else {
      return "Linux";
    }
  }

  // Windows
  var isWindows = (navigator.platform == "Win32") || (navigator.platform == "Windows");
  if (isWindows) {
    var isWindows2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
    if (isWindows2K) return "Windows 2000";
    var isWindowsXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
    if (isWindowsXP) return "Windows XP";
    var isWindows2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
    if (isWindows2003) return "Windows 2003";
    var isWindowsVista= sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
    if (isWindowsVista) return "Windows Vista";
    var isWindows7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
    if (isWindows7) return "Windows 7";
    var isWindows8 = sUserAgent.indexOf("Windows NT 6.2") > -1 || sUserAgent.indexOf("Windows NT 6.3") > -1 || sUserAgent.indexOf("Windows 8") > -1;
    if (isWindows8) return "Windows 8";
    var isWindows10 = sUserAgent.indexOf("Windows NT 10.0") > -1 || sUserAgent.indexOf("Windows 10") > -1;
    if (isWindows10) return "Windows 10";
  }
  return "other";
}

// 时间戳转换成时间
export const timestampToTime = (timestamp, timeType, showType) => {
  if (timeType) timestamp = timestamp * 1000
  var date = new Date(timestamp) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y, M, D, h, m, s
  Y = date.getFullYear() + '-'
  M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  D = date.getDate() + ' '
  if (D < 10) D = `0${D}`
    h = date.getHours()
  if (h < 10) h = `0${h}`
    m = date.getMinutes()
  if (m < 10) m = `0${m}`
    s = date.getSeconds()
  if (s < 10) s = `0${s}`
  if (showType === 'YMD') {
    return Y + M + D
  } else if (showType === 'HMS') {
    return h + ':' + m + ':' + s
  } else if (showType === 'MS') {
    return m + ':' + s
  } else {
    return Y + M + D + h + ':' + m + ':' + s
  }
}